var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"custom-classes","enter-active-class":"animate__animated animate__zoomIn","leave-active-class":"animate__animated animate__zoomOut"}},[_c('h1',[_vm._v("test")])])}
var staticRenderFns = []

export { render, staticRenderFns }